import { useMutation, useQueryClient } from '@tanstack/react-query';
import useAuth from 'hooks/useAuth.ts';
import { apiFetch } from 'utils/apiUtils.ts';

interface UpdateTeamCohortsVariables {
  teamId: string;
  cohortLabels: string[];
}

interface UpdateTeamCohortsResponse {
  message: string;
}

export default function useUpdateTeamCohorts() {
  const { tokens } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['teamCohorts'],
    mutationFn: async ({ teamId, cohortLabels }: UpdateTeamCohortsVariables) => apiFetch<UpdateTeamCohortsResponse>({
      path: `team/${teamId}/cohorts`,
      method: 'PUT',
      accessToken: String(tokens.accessToken),
      body: cohortLabels,
    }),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['teamCohorts', { teamId: variables.teamId }],
      });
    },
  });
}
